import clsx from 'clsx';
import checkIcon from '../../../../jackpot/assets/check.svg';

const CustomCheckbox = ({ id, checked, onChange, label, className }) => (
  <div className={clsx("flex items-center space-x-3", className)}>
    <div className="relative flex-shrink-0 mt-1">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="sr-only"
      />
      <label
        htmlFor={id}
        className={clsx(
          'flex items-center border-solid border-1 border-gray-200  rounded-lg justify-center text-white w-8 h-8 cursor-pointer transition-colors duration-200',
          checked
            ? 'bg-white border-white'
            : 'border-gray-300 bg-transparent',
        )}
      >
        {checked && <img src={checkIcon} alt="check" className="w-4 h-4" />}
      </label>
    </div>
    <label
      htmlFor={id}
      className="text-lgpt-2 geomanistMedium font-normal h-full cursor-pointer leading-relaxed text-white"
    >
      {label}
    </label>
  </div>
);

export default CustomCheckbox;
